import { message } from 'antd';
import { create } from 'zustand';

import { defaultIcon } from '@/components/memory-container/components/topicCardItem/constant';
import {
  addSmartTopic,
  deleteSmartTopic,
  editSmartTopic,
  getSmartTopicList
} from '@/service/smart-topic';
import type { ISmartTopicAdd, ISmartTopicBasic, ISmartTopicListItem } from '@/service/smart-topic';

interface SmartTopicStore {
  topicList: ISmartTopicListItem[];
  updateTopicList: (topicList: ISmartTopicListItem[]) => void;
  initTopicList: () => void;
  updateTopicItem: (topic: ISmartTopicBasic, cb?: () => void) => void;
  addTopicItem: (topic: ISmartTopicAdd, cb?: () => void) => void;
  removeTopicItem: (topicId: number) => void;
  topTopicItem: (topicId: number) => void;
}

const useSmartTopicStore = create<SmartTopicStore>()((set, get) => ({
  topicList: [] as ISmartTopicListItem[],
  updateTopicList: (_topicList: ISmartTopicListItem[]) => {
    set({ topicList: _topicList });
    get().initTopicList();
  },
  initTopicList: () => {
    getSmartTopicList({}).then((res) => {
      if (res.data.code === 0) {
        const _res = res.data.data;
        const cleanedList = _res.list.map((topic) => ({
          ...topic,
          icon: topic.icon || defaultIcon
        }));

        set({ topicList: cleanedList });
      } else {
        message.error(res.data.message || 'Failed to get smart topic list.');
      }
    });
  },
  updateTopicItem: (topic: ISmartTopicBasic, cb?: () => void) => {
    const { topicList } = get();
    const newTopicList = topicList.map((item) => {
      if (item.id === topic.id) {
        return { ...item, ...topic };
      }

      return item;
    });

    set({ topicList: newTopicList });
    editSmartTopic(topic).finally(() => {
      get().topTopicItem(topic.id);
      get().initTopicList();
      cb?.();
    });
  },
  addTopicItem: (topic: ISmartTopicAdd, cb?: () => void) => {
    addSmartTopic(topic).then(() => {
      get().initTopicList();
      cb?.();
    });
  },
  removeTopicItem: (topicId: number) => {
    const { topicList } = get();
    const newTopicList = topicList.filter((item) => item.id !== topicId);

    set({ topicList: newTopicList });
    deleteSmartTopic({ id: topicId }).then((res) => {
      if (res.data.code === 0) {
        message.success('Delete success');
        get().initTopicList();
      } else {
        message.error('Delete failed');
      }
    });
  },
  topTopicItem: (topicId: number) => {
    const { topicList } = get();
    const newTopicList: ISmartTopicListItem[] = [...topicList];

    const index = newTopicList.findIndex((topic) => topic.id === topicId);

    if (index !== -1) {
      const [topic] = newTopicList.splice(index, 1);

      newTopicList.unshift(topic);
    }

    set({ topicList: newTopicList });
  }
}));

export default useSmartTopicStore;
